import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4" role="alert">
          <h1 className="text-2xl font-bold text-gray-800 mb-2">問題が発生しました</h1>
          <p className="text-gray-600 mb-6 text-center">
            申し訳ありません。ページの表示中にエラーが発生しました。お手数ですが、トップページからやり直してください。
          </p>
          <a
            href="/"
            className="px-6 py-3 bg-gradient-to-r from-primary-500 to-beauty-500 text-white font-semibold rounded-lg hover:from-primary-600 hover:to-beauty-600 transition-all"
          >
            ホームへ戻る
          </a>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
